/// <reference types="./AuthorizationAdapter.d.ts" />
import { notOk, ok } from '@dossierhq/core';
export const DefaultAuthorizationAdapter = {
    resolveAuthorizationKeys(_context, authKeys) {
        for (const authKey of authKeys) {
            return Promise.resolve(notOk.BadRequest(`The authKey ${authKey} doesn't exist`));
        }
        return Promise.resolve(ok([]));
    },
};
export const SubjectAuthorizationAdapter = {
    resolveAuthorizationKeys(context, authKeys) {
        const payload = [];
        for (const authKey of authKeys) {
            let resolvedAuthKey;
            if (authKey === 'subject') {
                if (!context.session.subjectId) {
                    continue;
                }
                else {
                    resolvedAuthKey = `subject:${context.session.subjectId}`;
                }
            }
            else {
                return Promise.resolve(notOk.BadRequest(`The authKey ${authKey} doesn't exist`));
            }
            payload.push({ authKey, resolvedAuthKey });
        }
        return Promise.resolve(ok(payload));
    },
};
//# sourceMappingURL=AuthorizationAdapter.js.map